import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/base/baseline.css";
import "../../styles/pages/services.css";

import "../../styles/module/collaborate.css";
import "../../styles/module/carousel.css";

import WhyUs from "../module/Why-Us";
import WebMgmtSlider from "../module/WebMgmt-Slider";
import Collaborate from "../module/Collaborate";
import FAQs from "../module/FAQs";
import Clients from "../module/Clients";

import bg2 from "../../assets/images/img/bg-2.webp";
// import bg3 from "../../assets/images/img/bg-3.svg";
import arrow from "../../assets/images/img/downarrow.webp";

export default function WebsiteManagement() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className=" landing__image-background-2 image-background scroll-from-left"
        />
        <div
          className="rotated-text"
          onClick={() => (window.location.href = "#scroll")}
        >
          <img src={arrow} alt="downarrow" className="" />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}> scroll down</font>
            </font>
          </h4>
        </div>
        <div className="section section__oferta">
          {/* <img
            className="landing__image-background-1 image-background slide-from-right"
            src={bg3}
            alt="container background"
          /> */}
          <div className="container oferta">
            <h5 className="drop-from-top" id="scroll">
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>service</font>
              </font>
            </h5>
            <div className="title drop-from-top">
              <h2 style={{ marginBottom: "30px" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Website Management Designed for Reliability and Growth
                  </font>
                </font>
              </h2>
            </div>
            <div className="description container__text">
              <p className="slide-from-left">
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    We manage and maintain websites with a focus on performance,
                    security, and user experience. Whether it's updating
                    content, optimizing for SEO, fixing bugs, or improving load
                    times— every detail is handled to ensure your site runs
                    smoothly and stays relevant.
                  </font>
                </font>
              </p>
              <p className="slide-from-right">
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Our goal is to keep your digital presence strong and
                    dependable. From routine updates to technical improvements,
                    we make sure your website evolves with your business,
                    supports your goals, and delivers consistent value to your
                    audience—day after day.
                  </font>
                </font>
              </p>
            </div>
          </div>
        </div>
        <WhyUs hideBackgroundImage={true} />
        <WebMgmtSlider />
        <Collaborate />
        <FAQs />

        <Clients />
      </div>
    </>
  );
}
